/** Canonical font-size scale (px) — numeric values for antd theme tokens. */
export const hireportFontSizes = {
  fontSizeSm: 12,
  fontSizeBase: 14,
  fontSizeLg: 16,
  fontSizeXl: 18,
  fontSize2xl: 20,
  fontSize3xl: 24,
  fontSize4xl: 28,
  fontSize5xl: 32,
} as const;

export type FontSizesTokens = typeof hireportFontSizes;
